
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
	mdiFolderCheckOutline,
	mdiRunFast,
	mdiAccountDetails,
  mdiNotebook,
  mdiGaugeLow,
	mdiViewDashboard,
  mdiChartBoxOutline,
  mdiTable,
  // mdiNoteOutline,
  mdiNewspaperVariantMultiple,
	mdiAvTimer,
	mdiAccountAlert,
	mdiBusDoubleDecker,
  mdiHumanMaleBoard,
	mdiOfficeBuilding,
	mdiAccountConvert,
	mdiCalendar,
	mdiSoccer,
  mdiAccountCheckOutline,
	mdiQrcodeScan,
  mdiEyeCheckOutline,
	mdiAccountSchool,
  mdiAccountMultiple,
	mdiCog,
  mdiMedicalBag,
	mdiAccount,
  mdiAccountCheck,
	mdiSchool,
	mdiComment,
	mdiGoogleClassroom,
	mdiBookshelf,
	mdiCashMultiple,
	mdiFlag,
  mdiAccountStarOutline,
  mdiAccountArrowRightOutline,
	mdiCalendarAccount,
	mdiAccountChild,
	mdiDoorOpen,
	mdiNeedle,
	mdiArrowUpBold,
  mdiTimelineOutline,
	mdiAccountOutline,
	mdiAccountCircle,
	mdiBookOpenVariant,
	mdiFaceAgent,
	mdiAccountGroup,
	mdiCalendarCursor,
	mdiClipboardAccount,
	mdiClipboardAccountOutline,
	mdiPuzzle,
	mdiAccountArrowLeft,
	mdiAccountArrowLeftOutline,
	mdiConsoleNetworkOutline,
	mdiTimetable,
	mdiCalendarMonth,
  mdiClipboardText,
	mdiBookOpenPageVariant,
	mdiHammerScrewdriver,
	mdiBookPlusMultiple,
	mdiFormatLetterMatches,
	mdiFormatListBulletedType,
	mdiNotebookEdit,
  mdiCalendarClock,
	mdiNumeric9BoxMultiple,
	mdiTimelineClockOutline,
	mdiCalendarEdit,
	mdiWatermark,
	mdiAccountMultiplePlus,
	mdiTrophyOutline,
  mdiSwapHorizontal,
  mdiFileCheckOutline,
  mdiDatabase,
  mdiDomainPlus,
  mdiStarCircle,
  mdiStarCircleOutline,
  mdiShapeOutline
} from '@mdi/js'

const menuAcademicAll = [
  {
    to: '/comboard-dashboard',
    icon: mdiViewDashboard,
    label: 'sidebar.dashboard'
  },
  {
    // label: 'Master',
    label: 'sidebarFin.master',
    subLabel: 'Submenus Master',
    icon: mdiCog,
    menu: [
      {
        to: '/academic-year',
        label: 'sidebarFin.acaYear',
        // label: 'Academic Year',
        icon: mdiCalendar
      },
      {
        to: '/financial-year',
        label: 'sidebarFin.finYear',
        // label: 'Financial Year',
        icon: mdiCalendarMonth
      },
      {
        to: '/academic-batch',
        label: 'sidebarFin.academicbatch',
        // label: 'Academic Batch',
        icon: mdiCalendarAccount
      },
      {
        to: '/department',
        label: 'sidebarFin.department',
        // label: 'Department',
        icon: mdiOfficeBuilding
      },
      {
        to: '/semester',
        label: 'sidebarFin.semester',
        // label: 'Semester',
        icon: mdiFlag
      },
      {
        to: '/phase',
        label: 'sidebarFin.phase',
        // label: 'Phase',
        icon: mdiTimelineOutline
      },
      {
        to: '/level',
        label: 'sidebarFin.level',
        // label: 'Level',
        icon: mdiArrowUpBold
      },
      {
        to: '/resignation-reason',
        label: 'sidebarFin.resignationReason',
        // label: 'Resignation Reason',
        icon: mdiBookOpenVariant
      },
      {
        to: '/class',
        label: 'sidebarFin.class',
        // label: 'Class',
        icon: mdiGoogleClassroom,
        updateMark: true
      },
      {
        to: '/work-unit',
        label: 'sidebarFin.workUnit',
        // label: 'Work Unit',
        icon: mdiOfficeBuilding,
        updateMark: true
      },
      {
        to: '/shift',
        label: 'sidebarFin.shift',
        // label: 'Shift',
        icon: mdiAccountConvert,
        updateMark: true
      },
      // {
      // 	to: '/extracuricular',
      // 	label: 'Extracuricular',
      // 	icon: mdiSoccer
      // },
      {
        to: '/vaccine',
        label: 'sidebarFin.vaccine',
        // label: 'Vaccine',
        icon: mdiNeedle
      },
      {
        to: '/comment',
        label: 'sidebarFin.comment',
        // label: 'Comment',
        icon: mdiComment
      },
      {
        to: '/batch-registration',
        label: 'sidebarFin.batchRegistration',
        // label: 'Batch Registration',
        icon: mdiCalendarCursor
      },
      {
        to: '/major',
        label: 'sidebarFin.major',
        // label: 'Major',
        icon: mdiSchool
      },
      {
        to: '/major-date',
        label: 'sidebarFin.event',
        // label: 'Event',
        icon: mdiSchool
      },
      {
        to: '/master-tag',
        label: 'sidebarFin.tag',
        // label: 'Tag',
        icon: mdiFlag
      },
      // {
      //   to: '/credit-status',
      //   label: 'sidebarFin.creditStatus',
        // label: 'Credit Status',
      //   icon: mdiPalette
      // }
      {
        to: '/behavior',
        label: 'sidebarFin.behavior',
        // label: 'Behavior',
        icon: mdiAccountStarOutline
      },
      {
        to: '/passing-term',
        label: 'sidebarFin.passingTerm',
        // label: 'Passing Term',
        icon: mdiAccountArrowRightOutline
      }
    ]
  },
  // {
  // 	label: 'Course Achievement',
  // 	to: '/coursework-achievement',
  // 	icon: mdiTrophyOutline
  // },
  // {
  // 	label: 'Master Course',
  // 	subLabel: 'Coursework Master',
  // 	icon: mdiViewModule,
  // 	menu: [
  // 		{
  // 			to: '/coursework',
  // 			label: 'Coursework',
  // 			icon: mdiBookEducationOutline
  // 		},
  // 		{
  // 			to: '/price-group',
  // 			label: 'Price Group',
  // 			icon: mdiTagMultiple
  // 		},
  // 		{
  // 			to: '/price-list',
  // 			label: 'Price List',
  // 			icon: mdiCurrencyUsd
  // 		},
  // 		{
  // 			to: '/non-academic-activity',
  // 			label: 'Non-Academic Activities',
  // 			icon: mdiRunFast
  // 		}
  // 	]
  // },
  // {
  // 	label: 'Comboard',
  // 	subLabel: 'Submenus Comboard',
  // 	icon: mdiComment
  // },
  {
    label: 'sidebarFin.candidates',
    // label: 'Candidates',
    subLabel: 'Submenus Candidates',
    icon: mdiAccountChild,
    menu: [
      {
        to: '/new-batch-registration',
        label: 'sidebarFin.newBatchRegistration',
        // label: 'New Batch Registration',
        icon: mdiDoorOpen
      },
      {
        to: '/candidates-group',
        label: 'sidebarFin.candidatesGroup',
        // label: 'Candidates Group',
        icon: mdiAccountOutline
      },
      {
        to: '/candidate',
        label: 'sidebarFin.candidate',
        // label: 'Candidate',
        icon: mdiAccountOutline
      },
      // {
      // 	to: '/candidate-doc',
      // 	label: 'Candidate Documents',
      // 	icon: mdiAccountGroup
      // },
      {
        to: '/candidates-placement',
        label: 'sidebarFin.candidatesPlacement',
        // label: 'Candidates Placement',
        icon: mdiAccountOutline
      }
    ]
  },
  {
    label: 'sidebarFin.students',
    // label: 'Student',
    subLabel: 'Submenus Student',
    icon: mdiAccountCircle,
    menu: [
      {
        to: '/students',
        label: 'sidebarFin.students',
        // label: 'Students',
        icon: mdiAccountGroup
      },
      // {
      // 	to: '/student-doc',
      // 	label: 'Student Documents',
      // 	icon: mdiAccountGroup
      // },
      // {
      // 	to: '/parent-user',
      // 	label: 'Parents',
      // 	icon: mdiAccount
      // },
      // {
      // 	to: '/',
      // 	label: 'Users',
      // 	icon: mdiAccountMultiple
      // },
      {
        to: '/non-academic-activity',
        label: 'sidebarFin.nonAcademicActivity',
        // label: 'Non-Academic Activities',
        icon: mdiRunFast
      },
      {
        to: '/student-achievement',
        label: 'sidebarFin.studentAchievement',
        // label: 'Student Achievement',
        icon: mdiTrophyOutline
      },
      {
        to: '/class-transfer',
        label: 'sidebarFin.classTransfer',
        // label: 'Class Transfer',
        icon: mdiAccountMultiplePlus
      },
      {
        to: '/student-resignation',
        label: 'sidebarFin.resignation',
        // label: 'Resignation',
        icon: mdiAccountGroup
      },
      {
        to: '/graduation',
        label: 'sidebarFin.graduation',
        // label: 'Graduation',
        icon: mdiAccountSchool
      },
      {
        to: '/siblings-report',
        label: 'sidebarFin.siblingsReport',
        // label: 'Siblings Report',
        icon: mdiAccountMultiple
      }
    ]
  },
  {
    to: '/parent-user',
    label: 'sidebarFin.parents',
    // label: 'Parents',
    icon: mdiAccount
  },
  // {
  // 	label: 'Generate',
  // 	to: '/generate-userid',
  // 	icon: mdiAccountCircle
  // },
  {
    label: 'sidebarFin.employee',
    // label: 'Employee',
    subLabel: 'Employee',
    icon: mdiAccountCircle,
    menu: [
      {
        to: '/employee',
        label: 'sidebarFin.employee',
        // label: 'Employees',
        icon: mdiAccount
      },
      {
        to: '/employee-daily-attendance',
        label: 'sidebarFin.employeeDailyAttendance',
        // label: 'Employee Daily Attendance',
        icon: mdiAccountCheck
      },
      {
        to: '/employee-special-assignments',
        label: 'sidebarFin.employeeSpecialAssignments',
        // label: 'Special Employee Assignments',
        icon: mdiClipboardAccountOutline
      },
      {
        to: '/employee-attendance-report',
        label: 'sidebarFin.employeeAttendanceReport',
        // label: 'Employee Attendance Report',
        icon: mdiAccountCheck
      }
    ]
  },
  {
    label: 'sidebarFin.subject',
    // label: 'Subject',
    subLabel: 'Submenus Subject',
    icon: mdiBookOpenVariant,
    menu: [
      {
        to: '/subject',
        label: 'sidebarFin.subject',
        // label: 'Subject',
        icon: mdiBookshelf
      },
      {
        to: '/subject-group',
        label: 'sidebarFin.subjectGroup',
        // label: 'Subject Group',
        icon: mdiBookOpenPageVariant
      },
      {
        to: '/learning-method',
        label: 'sidebarFin.learningMethod',
        // label: 'Learning Method',
        icon: mdiBookPlusMultiple
      },
      {
        to: '/grading-master',
        label: 'sidebarFin.gradingMaster',
        // label: 'Grading Master',
        icon: mdiHammerScrewdriver
      },
      {
        to: '/grading-aspects',
        label: 'sidebarFin.gradingAspects',
        // label: 'Grading Aspects',
        icon: mdiHammerScrewdriver
      },
      {
        to: '/grading-extracurricular',
        label: 'sidebarFin.gradingExtracurricular',
        // label: 'Grading Extracurricular',
        icon: mdiHammerScrewdriver
      },
      {
        to: '/aspect-academic-year',
        label: 'sidebarFin.aspectAcademicYear',
        // label: 'Aspect Academic Year',
        icon: mdiCalendarMonth
      },
      {
        to: '/aspect-assignment-level',
        label: 'sidebarFin.aspectAssignmentLevel',
        // label: 'Aspect Assignment Level',
        icon: mdiClipboardText
      },
      {
        to: '/assignment-type',
        label: 'sidebarFin.assignmentType',
        // label: 'Assignment Type',
        icon: mdiFormatListBulletedType
      },
      {
        to: '/grading-rule',
        label: 'sidebarFin.gradingRule',
        // label: 'Grading Criteria',
        icon: mdiFormatLetterMatches
      },
      {
        to: '/grading-rule-level',
        label: 'sidebarFin.gradingRuleLevel',
        // label: 'Grading Criteria P5',
        icon: mdiFormatLetterMatches
      },
      {
        to: '/final-score-rule',
        label: 'sidebarFin.finalScoreRule',
        // label: 'Final Score Rule',
        icon: mdiNumeric9BoxMultiple
      },
      {
        to: '/scoreminimum',
        label: 'sidebarFin.passingGrade',
        // label: 'Passing Grade',
        icon: mdiNumeric9BoxMultiple
      },
      {
        to: '/syllabus',
        label: 'sidebarFin.syllabus',
        // label: 'Syllabus',
        icon: mdiNotebookEdit
      },
      {
        to: '/teaching-time-plan',
        label: 'sidebarFin.teachingTimePlan',
        // label: 'Teaching Timeplan',
        icon: mdiTimelineClockOutline
      },
      {
        to: '/teaching-term-plan',
        // label: 'sidebarFin.teachingTermPlan',
        label: 'Teaching Term Plan',
        icon: mdiCalendarEdit
      },
      {
        to: '/lesson-plan',
        label: 'sidebarFin.lessonPlan',
        // label: 'Lesson Plan',
        icon: mdiPuzzle
      },
      {
        to: '/lesson-plan-summary',
        label: 'sidebarFin.lessonPlanSummary',
        // label: 'Lesson Plan Summary',
        icon: mdiPuzzle
      },
      {
        to: '/student-paralel-subject',
        label: 'sidebarFin.studentParallelSubject',
        // label: 'Student Parallel Subject',
        icon: mdiAccountDetails
      },
      {
        to: '/student-select-subject',
        label: 'sidebarFin.studentSelectSubject',
        // label: 'Student Subject Selection',
        icon: mdiAccountDetails
      }
    ]
  },
  {
    label: 'sidebarFin.extracurricular',
    // label: 'Extracuricular',
    subLabel: 'Submenus Extracuricular',
    icon: mdiSoccer,
    menu: [
      {
        to: '/extracuricular',
        label: 'sidebarFin.extracurricular',
        // label: 'Extracuricular',
        icon: mdiSoccer
      },
      {
        to: '/extracuricular-group',
        label: 'sidebarFin.extracuricularGroup',
        // label: 'Extracuricular Group',
        icon: mdiSoccer
      },
      {
        to: '/extracuricular-student',
        label: 'sidebarFin.extracurricularStudent',
        // label: 'Student Extracuricular',
        icon: mdiAccountDetails
      },
      {
        to: '/extracuricular-student-select',
        label: 'sidebarFin.extracurricularStudentSelect',
        // label: 'Student Extracuricular Selection',
        icon: mdiAccountDetails
      },
      {
        to: '/extracuricular-attendance',
        label: 'Extracuricular Attendance',
        icon: mdiAccountCheckOutline
      }
      // {
      // 	to: '/extracuricularbarchart',
      // 	label: 'Report Extracuricular',
      // 	icon: mdiAccountDetails
      // }
    ]
  },
  {
    label: 'sidebarFin.teacher',
    // label: 'Teacher',
    subLabel: 'Submenus Teacher',
    icon: mdiClipboardAccount,
    menu: [
      {
        to: '/teacher',
        label: 'sidebarFin.teacher',
        // label: 'Teacher',
        icon: mdiClipboardAccountOutline
      },
      {
        to: '/teacher-extracuricular',
        label: 'sidebarFin.extracurricularTeacher',
        // label: 'Extracurricular Teacher',
        icon: mdiSoccer
      },
      {
        to: '/teacher-note',
        label: 'sidebarFin.teacherNote',
        // label: 'Teacher Note',
        icon: mdiAccountDetails
      },
      {
        to: '/teacher-journal-report',
        label: 'Teacher Journal',
        icon: mdiNotebook
      },
      {
        to: '/teacher-time-table',
        label: 'Teacher Schedule',
        icon: mdiCalendarClock
      },
      {
        to: '/scan-asset',
        label: 'sidebarFin.scanAsset',
        // label: 'Scan Asset',
        icon: mdiQrcodeScan
      },
      {
        to: '/scan-asset-location',
        label: 'sidebarFin.scanAssetLocation',
        // label: 'Scan Asset Location',
        icon: mdiQrcodeScan
      },
      // {
      // 	to: '/teacherjournal',
      // 	label: 'Teacher Journal',
      // 	icon: mdiFileDocument
      // }
      {
        to: '/student-observation',
        label: 'sidebarFin.studentObservation',
        // label: 'Student Observation',
        icon: mdiEyeCheckOutline
      },
      {
        to: '/teacher-performance-summary',
        label: 'sidebarFin.teacherPerformanceSummary',
        // label: 'Teacher Performance Summary',
        icon: mdiAccountStarOutline
      }
    ]
  },
  {
    label: 'sidebarFin.transaction',
    // label: 'Transaction',
    subLabel: 'Transaction',
    icon: mdiCashMultiple,
    menu: [
      {
        to: '/transaction-type',
        label: 'sidebarFin.transactionType',
        // label: 'Transaction Type',
        icon: mdiCashMultiple
      },
      {
        to: '/transaction-group',
        label: 'sidebarFin.transactionGroup',
        // label: 'Transaction Group',
        icon: mdiCashMultiple
      }
    ]
  },
  // {
  // 	label: 'Incomes',
  // 	subLabel: 'Payment',
  // 	icon: mdiAccountCash,
  // 	menu: [
  // 		{
  // 			to: '/paymenttransaction',
  // 			label: 'Payment',
  // 			icon: mdiCashMultiple
  // 		},
  // 		{
  // 			to: '/income',
  // 			label: 'Income',
  // 			icon: mdiCashMultiple
  // 		}
  // 	]
  // },
  {
    label: 'sidebarFin.permissionRequest',
    // label: 'Permission Request',
    subLabel: 'Submenus Teacher',
    icon: mdiFaceAgent,
    menu: [
      {
        to: '/permissions',
        label: 'sidebarFin.permissions',
        // label: 'Permissions',
        icon: mdiFaceAgent
      },
          {
        to: '/permission-reason',
        label: 'sidebarFin.permissionReason',
        // label: 'Permission Reason',
        icon: mdiFaceAgent
      }
    ]
  },
  {
    label: 'sidebarFin.schedule',
    // label: 'Schedule',
    subLabel: 'Submenus Schedule',
    icon: mdiTimetable,
    menu: [
        {
        to: '/school-time',
        label: 'sidebarFin.schoolTime',
        // label: 'School Time',
        icon: mdiAvTimer
      },
      {
        to: '/study-time',
        label: 'sidebarFin.studyTime',
        // label: 'Study Time',
        icon: mdiAvTimer
      },
      {
        to: '/schedule',
        label: 'sidebarFin.schedule',
        // label: 'Schedule',
        icon: mdiTimetable
      },
      {
        to: '/extracuricular-schedule',
        label: 'sidebarFin.extracuricularSchedule',
        // label: 'Extracuricular Schedule',
        icon: mdiTimetable
      },
      {
        to: '/calendar',
        label: 'sidebarFin.calendar',
        // label: 'Calendar',
        icon: mdiCalendarMonth
      }
    ]
  },
  {
    to: '/school-events',
    label: 'sidebarFin.schoolEvents',
    // label: 'School Events',
    icon: mdiCalendar
  },
  {
    label: 'sidebarFin.attendance',
    // label: 'Attendance',
    subLabel: 'Submenus Attendance',
    icon: mdiAccountArrowLeft,
    menu: [
      {
        to: '/daily-attendance',
        label: 'sidebarFin.dailyAttendance',
        // label: 'Daily Attendance',
        icon: mdiConsoleNetworkOutline
      },
      {
        to: '/regular-subject-attendance',
        label: 'sidebarFin.regularSubject',
        // label: 'Regular Subject',
        icon: mdiAccountArrowLeftOutline
      },
      {
        to: '/parallel-subject',
        label: 'sidebarFin.parallelSubject',
        // label: 'Parallel Subject',
        icon: mdiAccountArrowLeftOutline
      },
      {
        to: '/report-attendance-daily',
        label: 'sidebarFin.dailyAttendanceReport',
        // label: 'Daily Attendance Report',
        icon: mdiAccountAlert
      },
      {
        to: '/summary-report',
        label: 'sidebarFin.summaryReport',
        // label: 'Summary Report',
        icon: mdiAccountAlert
      },
      {
        to: '/assignment-special',
        label: 'sidebarFin.specialAssignment',
        // label: 'Special Assignment',
        icon: mdiBusDoubleDecker
      },
      {
        to: '/subject-attendance',
        label: 'sidebarFin.regularSubjectAttendance',
        // label: 'Regular Subject Attendance',
        icon: mdiHumanMaleBoard
      },
      {
        to: '/scan-daily-attendance',
        // label: 'sidebarFin.scanAssetLocation',
        label: 'Scan Daily Attendance',
        icon: mdiQrcodeScan
      }
    ]
  },
  {
    label: 'sidebarFin.subjectAssessment',
    // label: 'Subject Assessment',
    subLabel: 'Submenus Subject Assessment',
    icon: mdiSchool,
    menu: [
      {
        to: '/lesson-assessment-regular',
        label: 'sidebarFin.regular',
        // label: 'Regular',
        icon: mdiSchool
      },
      // {
      //   to: '/lesson-assessment-regular-subtopic',
      //   label: 'Regular by Sub Topic',
      //   icon: mdiSchool
      // },
      {
        to: '/lesson-assessment-parallel',
        label: 'sidebarFin.parallel',
        // label: 'Parallel',
        icon: mdiSchool
      },
      {
        to: '/ledger-homeroom-attidude',
        label: 'sidebarFin.ledgerHomeroomAttidude',
        // label: 'Homeroom Ledger Kokurikuler',
        icon: mdiSchool
      },
      {
        to: '/ledger-homeroom-teacher',
        label: 'sidebarFin.ledgerHomeroomTeacher',
        // label: 'Homeroom Ledger',
        icon: mdiSchool
      },
      {
        to: '/extracuricular-score',
        label: 'sidebarFin.extracuricularScore',
        // label: 'Extracuricular Score',
        icon: mdiSchool
      },
      {
        to: '/class-average',
        label: 'sidebarFin.classAverage',
        // label: 'Class Average',
        icon: mdiSchool
      },
      {
        to: '/under-cma',
        label: 'sidebarFin.underCma',
        // label: 'Under CMA',
        icon: mdiGaugeLow
      },
      {
        to: '/score-transfer',
        label: 'sidebarFin.scoreTransfer',
        // label: 'Score Transfer',
        icon: mdiSwapHorizontal
      }
      // {
      //   to: '/aspect-assignment-score',
      //   label: 'Aspect Assignment Score',
      //   icon: mdiNumeric10CircleOutline
      // }
    ]
  },
  {
    key: 'NON_ACADEMIC_ACCOMPLISHMENTS',
    label: 'Non Academic Accomplishments',
    subLabel: 'Submenus Non Academic Accomplishments',
    icon: mdiTrophyOutline,
    menu: [
      {
        to: '/dashboard-non-academic-accomplishments',
        // label: 'sidebarFin.report',
        label: 'Dashboard',
        icon: mdiViewDashboard
      },
      // {
      //   label: 'Summary',
      //   subLabel: 'Summary',
      //   icon: mdiNewspaperVariantMultiple,
      //   menu: [
      //     {
      //       to: '/summary-cca/class',
      //       label: 'CCA (Class)',
      //       icon: mdiNoteOutline
      //     },
      //     {
      //       to: '/summary-cca/department',
      //       label: 'CCA (Department)',
      //       icon: mdiNoteOutline
      //     },
      //     {
      //       to: '/summary-cca/school',
      //       label: 'CCA (School)',
      //       icon: mdiNoteOutline
      //     }
      //   ]
      // },
      {
        label: 'Master',
        subLabel: 'Submenus Master',
        icon: mdiDatabase,
        menu: [
          {
            to: '/department-accomplishment',
            label: 'Department Accomplishment',
            icon: mdiDomainPlus
          },
          {
            to: '/cocurricular-type',
            label: 'Cocurricular Type',
            icon: mdiShapeOutline
          },
          {
            to: '/cocurricular',
            label: 'Cocurricular',
            icon: mdiStarCircleOutline
          }
        ]
      },
      {
        to: '/tr-cocurricular',
        label: 'Cocurricular',
        icon: mdiStarCircle
      },
      {
        label: 'Settings',
        subLabel: 'Submenus Settings',
        icon: mdiCog,
        menu: [
          {
            to: '/cocurricular-approval',
            label: 'Cocurricular Approval',
            icon: mdiFileCheckOutline
          },
          {
            to: '/cocurricular-approver',
            label: 'Cocurricular Approver',
            icon: mdiAccountCheckOutline
          }
        ]
      },
      {
        to: '/non-academic-accomplishment-summary',
        label: 'Summary',
        icon: mdiNewspaperVariantMultiple
      },
      {
        label: 'Reports',
        subLabel: 'Reports',
        icon: mdiChartBoxOutline,
        menu: [
          {
            to: '/report-cca/class',
            label: 'CCA (Class)',
            icon: mdiTable
          },
          {
            to: '/report-cca/department',
            label: 'CCA (Department)',
            icon: mdiTable
          },
          {
            to: '/report-cca/school',
            label: 'CCA (School)',
            icon: mdiTable
          }
        ]
      }
    ]
  },
  {
    label: 'sidebarFin.report',
    // label: 'Report',
    subLabel: 'Submenus Report',
    icon: mdiSchool,
    menu: [
      {
        to: '/student-raport',
        label: 'sidebarFin.report',
        // label: 'Report',
        icon: mdiSchool
      },
      {
        to: '/passing-term-report',
        // label: 'sidebarFin.students',
        label: 'Passing Term Report',
        icon: mdiSchool
      }
    ]
  },
  {
    label: 'sidebarFin.roles',
    // label: 'Roles',
    subLabel: 'Roles',
    icon: mdiFaceAgent,
    menu: [
      {
        to: '/role',
        label: 'sidebarFin.roles',
        // label: 'Role',
        icon: mdiFaceAgent
      },
      {
        to: '/role-group',
        label: 'sidebarFin.roleGroup',
        // label: 'Role Group',
        icon: mdiFaceAgent
      }
    ]
  },
  {
    label: 'sidebarFin.settings',
    // label: 'Settings',
    subLabel: 'Submenus Settings',
    icon: mdiCog,
    menu: [
      {
        to: '/schoolidentity',
        label: 'sidebarFin.schoolIdentity',
        // label: 'School Identity',
        icon: mdiSchool
      },
      {
        to: '/branch',
        label: 'sidebarFin.branch',
        // label: 'Branch',
        icon: mdiWatermark
      },
      {
        to: '/users',
        label: 'sidebarFin.users',
        // label: 'Users',
        icon: mdiAccount
      },
      {
        to: '/general-setting',
        label: 'sidebarFin.generalSetting',
        // label: 'General Setting',
        icon: mdiCog
      },
      {
        to: '/active-docmag',
        label: 'sidebarFin.activateManagement',
        // label: 'Activate Management',
        icon: mdiFolderCheckOutline
      },
      {
        to: '/ocr-recognize',
        label: 'OCR Recognize',
        // label: 'Activate Management',
        icon: mdiFolderCheckOutline
      },
      // {
      //   to: '/unapprove-mechanism',
      //   label: 'Unapprove Mechanism',
      //   icon: mdiAccountWrench
      // },
      // {
      //   to: '/settingattendance',
      //   label: 'Setting Attendance',
      //   icon: mdiPen
      // },
      // {
      //   to: '/settingspeed',
      //   label: 'Chart & Analysis Setting',
      //   icon: mdiChartBar
      // },
      // {
      //   to: '/settingtimeout',
      //   label: 'Setting Major & Cross Major',
      //   icon: mdiTimelineClockOutline
      // },
      // {
      //   to: '/settingextracuricular',
      //   label: 'Setting Extracuricular',
      //   icon: mdiTimelineClockOutline
      // },
      // {
      //   to: '/settingmodule',
      //   label: 'Setting Module',
      //   icon: mdiBookOpenPageVariant
      // },
      {
        to: '/template-announcement',
        label: 'sidebarFin.templateAnnouncement',
        // label: 'Template Announcement',
        icon: mdiSchool
      },
      {
        to: '/module-setting',
        label: 'sidebarFin.moduleSetting',
        // label: 'Module Setting',
        icon: mdiCog
      },
      {
        to: '/medical-record',
        label: 'sidebarFin.medicalRecord',
        // label: 'Medical Record',
        icon: mdiMedicalBag
      }
    ]
  }
]
export default menuAcademicAll
